import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Icon from '../../common/icons/Icon';

import FollowUpListItem from './FollowUpListItem';

class FollowUpList extends Component {
  static propTypes = {
    headerTitle: PropTypes.string.isRequired,
    onItemView: PropTypes.func.isRequired,
    sessions: PropTypes.array.isRequired,
    showHistory: PropTypes.func,
    type: PropTypes.string.isRequired,
  };

  render() {
    const { icon, headerTitle, type, sessions, onItemView, showHistory } = this.props;

    return (
      <div className="session-list">
        <div className="session-list__header">
          <Icon icon={icon} />
          <h3>{headerTitle}</h3>
        </div>
        {sessions.length ? (
          sessions.map((session, index) => {
            return (
              <FollowUpListItem
                key={index}
                session={session}
                type={type}
                onClickItem={session => onItemView(session)}
              />
            );
          })
        ) : (
          <div className="session-list__no-sessions">No Follow-Ups</div>
        )}
        {type === 'completed' &&
        sessions.length === 5 && (
          <span onClick={showHistory} className="a show-history">
            Show History
          </span>
        )}
      </div>
    );
  }
}

export default FollowUpList;



// WEBPACK FOOTER //
// ./src/follow-ups/common/FollowUpList.js